import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Input,
  Table
} from "reactstrap";
import { useAuth } from "context/AuthProvider";
import FormMotivoAusencias from "./FormMotivoAusencias";
import { showAppAlert } from "components/common/AppAlerts";

import{ apiMotivoAusenciasService } from "services/apiMotivoAusenciasService"; 


const ListMotivoAusenciasImpl = (props) => {
 const { empresa } = useAuth();
  const [motivos, setMotivos] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
    const [newDescripcion, setNewDescripcion] = useState(undefined);
    const [diasPermitidos, setDiasPermitidos] = useState(undefined);
    const [tipoComputoDias, setTipoComputoDias] = useState("HABILES");

    const [editingMotivo, setEditingMotivo] = useState(null);
    const [update, setUpdate] = useState(false);
  

  useEffect(() => {
    const fetchMotivos = async () => {
      try {
        const response = await apiMotivoAusenciasService.getAllByID(empresa.id);
        response.json().then((data) => {
            setMotivos(data);
        })
      } catch (error) {
        console.error("Error al obtener los motivos de ausencia:", error);
      }
    };
    fetchMotivos();
  }, [modalOpen, update])
  

  const toggleModal = () => {
    setNewDescripcion(""); 
    setDiasPermitidos("");
    setTipoComputoDias("HABILES");
    setEditingMotivo(null);
    setUpdate(!update);
    setModalOpen(!modalOpen);
  };



  const handleCreateMotivo = async (e) => {
    e.preventDefault();

    const newMotivo = {
      descripcion: newDescripcion,
      diasPermitidos: diasPermitidos,
      tipoComputoDias: tipoComputoDias || "HABILES",
    };

    try {
      if(editingMotivo)
      {
      await apiMotivoAusenciasService.update(newMotivo, editingMotivo.id)
      showAppAlert("Editado correctamente.", "success")
      }
      else
      {
      await apiMotivoAusenciasService.create(newMotivo, empresa.id);
      showAppAlert("Creado correctamente.", "success")
      }
      setNewDescripcion(""); 
      setDiasPermitidos("");
      setTipoComputoDias("HABILES");
      toggleModal();
      setEditingMotivo(null);
      setUpdate(!update);
    } catch (error) {
      showAppAlert("Error al crear el motivo.", "error")
    }
  };

  function handleEditar(motivo) {
    setEditingMotivo(motivo);
    setNewDescripcion(motivo.descripcion);
    setDiasPermitidos(motivo.diasPermitidos != null ? `${motivo.diasPermitidos}` : "");
    setTipoComputoDias(motivo.tipoComputoDias || "HABILES");
    setModalOpen(true);
  }

    async function handleEliminar(id) {
        if(!window.confirm("¿Eliminar el registro?")){
            return;
        }

        const response = await apiMotivoAusenciasService.delete(id);
        if(response.status === 204){
            showAppAlert("eliminado", "success");
            setUpdate(!update);
        }else{
            showAppAlert("Error al eliminar el registro", "error");
        }

    }

    return (
    <>
      <Card className="shadow">
            
            <CardBody>
            <h6 className="heading-small text-right mb-4">
            <Button className="btn btn-primary text-right" color='primary' onClick={toggleModal}>
              +
            </Button>
            </h6>
              <Table>
              <thead>

              <th>descripciones</th>
              <th>Días permitidos</th>
              <th>Tipo de cómputo</th>
              <th></th>
  
              </thead>
              <tbody>
              {motivos.length > 0 ? (
                motivos.map((motivo, index) => (
                  <tr key={index}>
                      <td>{motivo.descripcion}</td>
                      <td>{motivo.diasPermitidos}</td>
                      <td>{motivo.tipoComputoDias === "NATURALES" ? "Naturales" : "Habiles"}</td>

                     <td className="text-right">
                         <Button className={"btn-success"} onClick={() =>handleEditar(motivo)}>Editar</Button>
                         <Button className={"btn-danger"} onClick={() => handleEliminar(motivo.id)}>Eliminar</Button>
                     </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td>No hay datos disponibles</td>
                </tr>
              )}
              </tbody>
              </Table>
              
            </CardBody>
  
      </Card>
      
      <FormMotivoAusencias 
      modalOpen={modalOpen}
      toggleModal={toggleModal}
      handleCreateMotivo={handleCreateMotivo}
      newDescripcion={newDescripcion}
      setNewDescripcion={setNewDescripcion}
      diasPermitidos={diasPermitidos}
      setDiasPermitidos={setDiasPermitidos}
      tipoComputoDias={tipoComputoDias}
      setTipoComputoDias={setTipoComputoDias}
      />

    </>
  );
};

export default ListMotivoAusenciasImpl;
